import { Global, useTheme } from '@emotion/react';

export const GlobalStyles = () => {
  const theme = useTheme();

  return (
    <Global
      styles={{
        body: {
          fontFamily: theme.fontFamily.body,
          fontSize: 18,
          lineHeight: 1.3,
          margin: 0
        }
      }}
    />
  );
};

GlobalStyles.displayName = 'GlobalStyles';
